import { useEffect, useState } from "react";
import { LAccordion, LBtn, LHero, LModal, Loader } from "@components";
import { useApi } from "@services/useApi";
import { Documentation, DocumentationCategory } from "../../../common/store/generalTypes";
import { DocumentList } from "../components/documentList";
import { FaqList } from "../components/faqList";
import { CreateDocumentation } from "../components/createDocumentation";
import { useUserPermission } from "@helpers/userPermissionHelper";
import { ContactInformation } from "../components/contactInformation";

export const SupportTraining = (): JSX.Element => {
    const [isLoading, setIsLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [documentations, setDocumentations] = useState<Documentation[]>([]);
    const { getDocumentations } = useApi();
    const { isSuperAdmin } = useUserPermission({});

    useEffect(() => {
        void loadDocumentations();
    }, []);

    const loadDocumentations = async (): Promise<void> => {
        const items = await getDocumentations();
        setDocumentations(items);

        setIsLoading(false);
    };

    const handleOnCreated = (): void => {
        setIsLoading(true);

        void loadDocumentations();
    };

    if (isLoading) {
        return <Loader />;
    }

    return (
        <>
            <LHero className="has-text-centered" contentCentered>
                <div className="is-size-4 has-text-weight-bold pb-4">Support and training documentation</div>
                <div className="is-size-6" style={{ width: "35%", margin: "0 auto" }}>
                    Here you’ll find training videos, documentation and ways to get support as you get started with
                    LASSI-D™.
                </div>
            </LHero>
            {isSuperAdmin && (
                <LBtn classes="mb-4" onClick={() => setShowModal(!showModal)} isBold fontSize="6h" smallSpacing>
                    {" + Add Support and training documentation "}
                </LBtn>
            )}
            <LAccordion title="Training videos" isFirst>
                <DocumentList
                    documents={documentations.filter((doc) => doc.category === DocumentationCategory.Video)}
                />
            </LAccordion>
            <LAccordion title="Documents">
                <DocumentList
                    documents={documentations.filter((doc) => doc.category === DocumentationCategory.Document)}
                    isDocument
                />
            </LAccordion>
            <LAccordion title="FAQ">
                <FaqList faqs={documentations.filter((doc) => doc.category === DocumentationCategory.Faq)} />
            </LAccordion>
            <LAccordion title="Contact Information" isLast>
                <ContactInformation />
            </LAccordion>
            {showModal && (
                <LModal
                    title="Add Support and training documentation"
                    width="s"
                    fullHeight={false}
                    onClose={() => setShowModal(false)}
                >
                    <CreateDocumentation onCreated={handleOnCreated} />
                </LModal>
            )}
        </>
    );
};
